;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { ViewType } from "@/types/view";

export const systemViewQueryKeys = {
	all: ["system-views"] as const,
	list: (workspaceId?: string) =>
		[
			...systemViewQueryKeys.all,
			ViewType.SYSTEM_VIEW,
			workspaceId ?? null,
		] as const,
};
